export default __webpack_public_path__ + "static/logo-f4bc54fe3502c3f42e25593e22f61437.svg";